import { IColumn } from '@kaleyra/emmy/dist/molecules/styledTable';
import React from 'react';
import Outgoing from '../../../../../../assets/MT.svg';
import Incoming from '../../../../../../assets/MO.svg';
import i18n from '../../../../../../i18n/i18n';
import { Tooltip, Tag, Table } from '@kaleyra/emmy';
import Styles from '../index.module.scss';
import cn from 'classnames';
import { date12HrFormat } from '../../../../../../utils';
import Info from '../../../../../../assets/InfoAlert.svg';
import moment from 'moment';
import store from '../../../../../../store/store';
import { IStateType } from '../../../../../../store/models/root.interface';
import { isEmpty, startCase } from 'lodash';

export const formatStartCase = (original: any) => {
	if (original?.interactive_type === 'address') {
		return i18n.t('addressMessageWA');
	}

	if (isEmpty(original?.format)) {
		return '-';
	}

	let resformat = original?.format.replaceAll('_', ' ');
	return startCase(resformat);
};

export const expandColumnMessageV1Body = (
	elementData: any
): React.ReactNode => {
	const { original } = elementData;
	return (
		<>
			<Table
				columns={[
					{
						header: '',
						accessor: '',
						width: '40%',
					},
					{
						header: i18n.t('mainCountry'),
						accessor: 'country',
						width: '7.25rem',
						headerClassName: `${Styles.expandTableHeader}`,

						Cell: ({ original }) => original.country || '-',
					},
					{
						header: i18n.t('BLD00963'),
						accessor: 'format',
						width: '7.25rem',
						headerClassName: `${Styles.expandTableHeader}`,
						Cell: ({ original }) => formatStartCase(original),
					},
				]}
				data={[original]}
			/>
		</>
	);
};

export const getTagElement = (original: any) => {
	let tagType: string, label: string;
	let Todate = '-';

	if (original.seen_at) {
		Todate = original.seen_at;
		tagType = 'inactive';
		label = i18n.t('BLD01588');
	} else if (original.delivered_at) {
		Todate = original.delivered_at;
		tagType = 'primary';
		label = i18n.t('overviewWidgetWhatsAppDelivered');
	} else if (original.failed_at) {
		Todate = original.failed_at;
		tagType = 'error';
		label = i18n.t('mainFailed');
	} else if (original['not_sent']) {
		Todate = original['not_sent'];
		tagType = 'error';
		label = i18n.t('notSentWALogTag');
	} else if (original.sent_at) {
		Todate = original.sent_at;
		tagType = 'success';
		label = i18n.t('BLD01515');
	} else {
		Todate = original.sent_at;
		tagType = 'success';
		label = i18n.t('BLD01515');
	}

	return (
		<>
			<Tag
				label={label}
				tagStyle={{
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					...(label == 'Seen' && {
						backgroundColor: 'rgb(99, 79, 211, 0.1)',
						color: '#634FD3',
						border: '1px solid #634FD3',
					}),
				}}
				type={tagType}
			/>

			{original.reason && (
				<Tooltip
					placement="top"
					title={original.reason || '-'}
					trigger={['click', 'hover']}
				>
					<img src={Info} className={Styles.alert} alt="info" />
				</Tooltip>
			)}
		</>
	);
};

export const getToDate = (original: any) => {
    if (original.seen_at) return original.seen_at;
    else if (original.delivered_at) return original.delivered_at;
	else if (original.failed_at) return original.failed_at;
	else if (original['not_sent']) return original['not_sent'];
	else if (original.sent_at) return original.sent_at;
    else return original.sent_at;
}

export const getConversationType = (type: string) => {
    const state: IStateType = store.getState();
    const { whatsappLogsData } = state.whatsappLogs;
    if('data' in whatsappLogsData){
        return whatsappLogsData?.data?.conversation_category[type] || "-"
    }
    return "-";
}

export const getMessageBody = (original: any) => {
	const messageType = original?.format;
	const templateFormats = [
		'template',
		'authenticationtemplate',
		'mediatemplate',
	];
	const mediaFormats = ['media'];

	if (templateFormats.includes(messageType)) {
		return (
			<>
				<div className={Styles.formatHeader}>{i18n.t('verifyTemplateName')}</div>
				<Tooltip
					placement="top"
					title={original?.template_name}
					trigger={['hover']}
				>
					<div className={cn(Styles.rowWrapper, Styles.descWrapper)}>
						{original?.template_name || '-'}
					</div>
				</Tooltip>
			</>
		);
	} else if (mediaFormats.includes(messageType)) {
		return (
			<>
				<div className={Styles.formatHeader}>{i18n.t('mediaCaptionWA')}</div>
				<Tooltip
					placement="top"
					title={original?.message_body}
					trigger={['hover']}
				>
					<div className={cn(Styles.rowWrapper, Styles.descWrapper)}>
						{original?.message_body || '-'}
					</div>
				</Tooltip>
			</>
		);
	} else {
		return (
			<>
				<Tooltip
					placement="top"
					title={original?.message_body}
					trigger={['hover']}
				>
					<div className={cn(Styles.rowWrapper, Styles.descWrapper)}>
						{original?.message_body || '-'}
					</div>
				</Tooltip>
			</>
		);
	}
};

export const MessageLogsV1 = (): Array<IColumn> => [
	{
		header: i18n.t('mainType'),
		accessor: 'message_direction',
		Cell: ({ original }) => (
			<Tooltip
				placement="top"
				title={original?.message_direction}
				trigger={['hover']}
			>
				{original?.message_direction?.toLowerCase() === 'incoming' ? (
					<img src={Incoming} alt="type" />
				) : (
					<img src={Outgoing} alt="type" />
				)}
			</Tooltip>
		),
	},
	{
		header: i18n.t('tableHeaderFrom'),
		accessor: 'from',
		Cell: ({ original }) => (
			<Tooltip placement="top" title={original.from} trigger={['hover']}>
				<div className={Styles.fromNumberWrapper}>
					<div className={cn(Styles.rowWrapper, Styles.dateStyle)}>
						{original.created_at
							? date12HrFormat(original.created_at, true)
							: '-'}
					</div>
					<div className={cn(Styles.rowWrapper, Styles.fromNumber)}>
						{'+' + original.from?.replace('+', '') || '-'}
					</div>
				</div>
			</Tooltip>
		),
	},
	{
		header: i18n.t('tableHeaderTo'),
		accessor: 'to',
		Cell: ({ original, index }) => (
				<div className={Styles.toNumberWrapper}>
					<div className={Styles.dateStyle}>
						{getToDate(original) ? date12HrFormat(getToDate(original),true):'-'}
					</div>
					<div className={Styles.toNumber}>
						<div className={Styles.rowWrapper}>
						<Tooltip
							placement="top"
							title={original.to || '-'}
							trigger={['hover']}
						>
							{ !isEmpty(original.to) ? ('+' + original.to?.replace('+', '')) : '-'}
							</Tooltip>
						</div>
						<div
							key={'status-' + index}
							className={Styles.statusInfo}
						>
							{getTagElement(original)}
						</div>
					</div>
				</div>
		),
	},
	{
		header: i18n.t('conversationCategoryLabel'),
		accessor: 'conversation_type',
		Cell: ({ original }) => (
			<Tooltip
				placement="top"
				title={original.conversation_type}
				trigger={['hover']}
			>
				<div className={cn(Styles.rowWrapper, Styles.categoryWrapper)}>
					{getConversationType(original.conversation_type)}
				</div>
			</Tooltip>
		),
	},
	{
		header: i18n.t('messageBody'),
		accessor: 'message_body',
		Cell: ({ original }) => (
			<div>
				{getMessageBody(original)}
			</div>
		),
	},
];

export const updateFiltersForV1 = (
	filters: any,
	selFilters: any,
	whatsappLogsData: any,
	remove?: boolean
) => {
	let appliedOb = {};
	const { status, created, format, conversation_type } = filters;

	if (format) {
		appliedOb = {
			...appliedOb,
			format: remove
				? selFilters.format
				: whatsappLogsData?.data?.format[format] || '',
		};
	}
	if (conversation_type) {
		appliedOb = {
			...appliedOb,
			conversation_type: remove
				? selFilters.conversation_type
				: whatsappLogsData?.data?.conversation_category[
						conversation_type
				  ] || '',
		};
	}
	if (status) {
		appliedOb = {
			...appliedOb,
			status: remove
				? selFilters.status
				: whatsappLogsData?.data?.status[status] || '',
		};
	}
	if (created) {
		let createdArr = created.split(',');
		const [start, end] = createdArr;
		const startDate = moment.unix(start).format('DD MMM YYYY');
		const endDate = moment.unix(end).format('DD MMM YYYY');
		appliedOb = {
			...appliedOb,
			created: remove
				? selFilters.created
				: `${i18n.t('KLR00112')} ${startDate} ${i18n.t(
						'KLR00113'
				  )} ${endDate}`,
		};
	}

	return appliedOb;
};
